import React from 'react';
import Translate from '../localization/localize';
import { LogVM } from '../../../models';
import { MessageType } from '../../../core/localization';
import './logs.scss';

const isJsxElement = (o: unknown | JSX.Element) =>
  (o as JSX.Element) && (o as JSX.Element).type;

export const LogEntry: React.FC<LogVM> = (log) => {
  const message: JSX.Element = isJsxElement(log.title) ? (
    (log.title as JSX.Element)
  ) : (
    <Translate message={log.title as MessageType} />
  );
  const subMessage: JSX.Element = isJsxElement(log.subtitle) ? (
    (log.subtitle as JSX.Element)
  ) : (
    <span className="ellipsis" title={log.subtitle as string}>
      <Translate message={(log.subtitle as MessageType) || ''} />
    </span>
  );
  const date = log.date.toLocaleDateString();
  const time = log.date.toLocaleTimeString();
  const datetime = `${date} ${time}`;
  const id = `log-entry-${log.date.valueOf()}`;
  return (
    <div className="log-entry" key={id}>
      <div className="log-header">
        <div className="log-date">{datetime}</div>
        <div className="log-status">{log.status}</div>
      </div>
      <div className="log-main">{message}</div>
      <div className="log-by">{subMessage}</div>
      <div className="log-actions">{log.actions}</div>
    </div>
  );
};

interface OwnProps {
  logs: LogVM[];
}
type Props = OwnProps;
const Logs: React.FC<Props> = ({ logs }) => {
  return (
    <div className="logs-box">
      {logs.map((l) => (
        <LogEntry key={l.date.valueOf()} {...l} />
      ))}
    </div>
  );
};

export default Logs;
